import React from 'react';
import KoobSpinner from '@koob/ui/src/components/KoobSpinner';
import { formatCurrency } from '@koob/utils';

// A rate discounted to nothing is still a rate, so zero is bookable: only
// the absence of an amount is not — no pricing at all, or the NaN the
// room-availability pass writes when the rooms that were selected have
// gone. Read as a truthy test, a free stay would price at "0" and be
// called unavailable in the same breath.
export default function TripDayHotelPriceLine({
  dayIndex,
  isIncludedHotel,
  isGroupLoading,
  isMinStayUnmet,
  hotel,
  hasBookablePrice,
  isRoomUnavailable,
  hotelPricingInfo,
  totalTravelers,
  t,
}: {
  dayIndex: number;
  isIncludedHotel: any;
  isGroupLoading: boolean;
  isMinStayUnmet: boolean;
  hotel: any;
  hasBookablePrice: boolean;
  isRoomUnavailable: any;
  hotelPricingInfo: any;
  totalTravelers: number;
  t: (key: string, options?: Record<string, any>) => string;
}) {
  return (
    <div
      className="text-sm font-medium"
      data-testid={`day-hotel-price-${dayIndex}`}
    >
      {!isIncludedHotel ? (
        <div>
          <div className="text-orange-600">
            {isGroupLoading ? (
              <KoobSpinner size={15} />
            ) : isMinStayUnmet ? (
              // Checked BEFORE the price: the availability API keeps sending
              // a price for a stay short of its minimum, but that is a
              // display fallback, not a bookable rate.
              <div className="text-xs text-red-500">
                {t('hotel:minimumStay', {
                  count: Number(hotel.minimumStay),
                })}
              </div>
            ) : hasBookablePrice && !isRoomUnavailable ? (
              <>
                {formatCurrency({
                  amount: hotelPricingInfo?.price,
                  currency: hotelPricingInfo?.currency,
                })}
                {totalTravelers > 0 && (
                  <div className="text-xs text-gray-600">
                    {formatCurrency({
                      amount: hotelPricingInfo.price / totalTravelers,
                      currency: hotelPricingInfo.currency,
                    })}{' '}
                    / PAX
                  </div>
                )}
              </>
            ) : (
              <span className="text-xs text-red-500">
                {t('compose.someRoomsNotAvailable')}
              </span>
            )}
          </div>
        </div>
      ) : (
        <div className="text-green-500">{t('compose.priceIncluded')}</div>
      )}
    </div>
  );
}
